//Angular
import {
    Component, OnInit, ViewContainerRef, Input, Output, EventEmitter, ComponentFactory, ReflectiveInjector,
    Compiler, Inject, ElementRef, Renderer
} from "@angular/core";

//Services
import { SysConfig } from "./../../../services/core/system-configuration.service";
import { SliderService } from "./../../../services/cms/slider.service";
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { TemplateService } from "./../../../services/settings/template.service";
import { CmsComponentService } from "./../../../services/cms/cms-component.service";

//Models
import { SliderViewModel } from "./../../../models/cms/cms-page";

import { Subscription } from 'rxjs/Subscription';
import { SeoService } from "../../../services/core/seo.service";


@Component({
    selector: "dy-slider",
    template: ""
})

export class SliderWidgetComponent implements OnInit 
{
    constructor
    (
        private _compiler: Compiler, 
        private componentHelper: ComponentHelperService, 
        private _elementRef: ViewContainerRef, 
        private templateService: TemplateService,
        private cmsComponentService: CmsComponentService,
        @Inject('isBrowser') private isBrowser: boolean
    ) {}

    @Input() id: string;
    @Input() type: string;
    @Input() parentSliderData: any;

    subManager = new Subscription();

    ngOnInit() {
        if (!this.isBrowser)
            return;

        if (this.parentSliderData != null) {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentSliderData);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }

        else {
            let sliderData: any;

            let sliderDataSub = this.cmsComponentService.getSliderData(this.type, this.id).subscribe(result => {
                sliderData = result;
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(sliderData);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            });

            this.subManager.add(sliderDataSub);
        }
    }

   ngOnDestroy() {
       //Called once, before the instance is destroyed.
       //Add 'implements OnDestroy' to the class.
       this.subManager.unsubscribe();
   }

   //private createSubComponent(template:string, sliderId: string, sliderType: string) {
   private createSubComponent(sliderData: any) {

       @Component({
           template:sliderData.TemplateHtml
       })

       class ChildComponent implements OnInit 
       {
            constructor
            (
                private sliderService: SliderService,
                @Inject('isBrowser') private isBrowser: boolean,
                private elementRef: ElementRef, 
                private renderer: Renderer
            ) 
            {
               this.renderer.setElementStyle
               (
                 this.elementRef.nativeElement,
                 'display',
                 this.isBrowser ? 'block' : 'none'
               );
            }

           slides: any = sliderData.Slides;
           sliderIsInit: boolean = false;

           ngOnInit() {}

           goToUrl(url)
           {
                if(url != null && url.length > 0)
                {
                    window.location.href = url;
                }
           }

           ngAfterViewChecked() 
           {
                if (!this.isBrowser || this.sliderIsInit) 
                {
                    return;
                }

                layoutTheme.initSlider();

                this.sliderIsInit = true;
           }
       }

       return ChildComponent;
   }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/core/widget/slider-widget.component.ts